import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        VRow,
        { staticClass: "justify-end", attrs: { dense: "" } },
        [
          _c(
            VTooltip,
            {
              attrs: { top: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function ({ on: onTooltip }) {
                    return [
                      _c(
                        VBtn,
                        _vm._g(
                          {
                            attrs: { color: "primary" },
                            on: { click: _vm.pesquisar },
                          },
                          { ...onTooltip }
                        ),
                        [_vm._v(" Pesquisar ")]
                      ),
                    ]
                  },
                },
              ]),
            },
            [_c("span", [_vm._v("Clique para pesquisar")])]
          ),
        ],
        1
      ),
      _vm.relatorio
        ? _c(
            VRow,
            { staticClass: "justify-center mx-1" },
            [
              _c(_vm.tipoMonitoramento, {
                tag: "component",
                attrs: {
                  relatorio: _vm.relatorio,
                  ano: `${_vm.anoAtual}`,
                  "is-geral": "",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }